import * as React from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '../utils/propStyles';
import Badge from './Badge';
import { DataStore } from '../stores/DataStore';
import { isDisabled } from '../utils/customPropStyles';
import Translate, { translate } from './Translate';
import Icon from './Icon';
import { computed } from 'mobx';

const Button = styled<any, any>('button')`
    ${propStyles};
    ${isDisabled};
    &:disabled {
        opacity: 0.5;
    }
`;

Button.defaultProps = {
    display: 'flex',
    flex: ['1 0 0', '0 1 auto'],
    alignItems: 'center',
    justifyContent: 'center',
    paddingX: 'md',
    paddingY: 'sm',
    margin: '0 0 0 10px',
    minHeight: '40px',
    fontSize: 'inherit',
    fontFamily: 'heading',
    fontWeight: 'medium',
    textTransform: 'uppercase',
    borderWidth: '1px',
    borderColor: 'gray300',
    borderStyle: 'solid',
    borderRadius: 'sm',
    boxShadow: 'sm',
    textAlign: 'center',
    color: 'body',
    bgColor: 'gray100',
    cursor: 'pointer',
    outline: 'none',
    selected: {
        color: 'white',
        bgColor: 'primary',
    },
    isDisabled: {
        cursor: 'auto',
    },
};

const StarIcon = styled<any, any>(Icon)``;

StarIcon.defaultProps = {
    height: '1.6em',
    width: '1.6em',
    margin: '0 0.25em 0 0',
};

const ButtonText = styled<any, any>('span')`
    ${propStyles};
`;

ButtonText.defaultProps = {
    display: ['none', 'inline'],
};

const WatchListBadge = styled(Badge)``;

WatchListBadge.defaultProps = {
    marginX: 'sm',
    color: 'white',
    bgColor: 'gray500',
    selected: {
        color: 'primary',
        bgColor: 'white',
    },
};

@inject('accessibilityStore', 'translationStore', 'dataStore')
@observer
class WatchListButton extends React.Component<any> {
    @computed
    get watchlistConfig() {
        const { dataStore } = this.props;
        return dataStore && (dataStore as DataStore).watchListConfig;
    }

    @computed
    get watchlistButtonText() {
        return (
            (this.watchlistConfig && this.watchlistConfig.label) || 'Watch List'
        );
    }

    @computed
    get watchlistButtonTitle() {
        return (
            (this.watchlistConfig && this.watchlistConfig.title) ||
            'Toggle Watch List'
        );
    }

    @computed
    get showIcon() {
        return this.watchlistConfig
            ? this.watchlistConfig.hideChild !== 'icon'
            : true;
    }

    @computed
    get showText() {
        return this.watchlistConfig
            ? this.watchlistConfig.hideChild !== 'text'
            : true;
    }

    @computed
    get icon() {
        let defaultIcon = 'WatchlistButtonOutlineIcon';
        let activeIcon = 'WatchlistButtonIcon';
        if (this.watchlistConfig && this.watchlistConfig.icon) {
            if (typeof this.watchlistConfig.icon === 'string') {
                defaultIcon = this.watchlistConfig.icon;
            } else {
                if (this.watchlistConfig.icon.default) {
                    defaultIcon = this.watchlistConfig.icon.default;
                }
                if (this.watchlistConfig.icon.active) {
                    activeIcon = this.watchlistConfig.icon.active;
                }
            }
        }
        return { defaultIcon, activeIcon };
    }

    @computed
    get iconFileName() {
        const { active } = this.props;
        return active ? this.icon.activeIcon : this.icon.defaultIcon;
    }

    render() {
        const {
            theme,
            translationStore,
            count,
            active,
            onClick,
            accessibilityStore,
            ...props
        } = this.props;

        return (
            <Button
                aria-label={accessibilityStore.buttonAccessibilityValue(
                    'WatchlistButton'
                )}
                title={translate(translationStore, this.watchlistButtonTitle)}
                onClick={onClick}
                data-selected={active}
                disabled={count === 0 && !active}
                data-metric-id={'watchlist-button'}
                {...props}
                {...theme.WatchListButton}
            >
                {this.showIcon && (
                    <StarIcon
                        fileName={this.iconFileName}
                        data-selected={active}
                        {...theme.WatchListButtonIcon}
                    />
                )}
                {this.showText && (
                    <ButtonText>
                        <Translate>{this.watchlistButtonText}</Translate>
                    </ButtonText>
                )}
                <WatchListBadge
                    data-selected={active}
                    {...theme.WatchListBadge}
                >
                    {count}
                </WatchListBadge>
            </Button>
        );
    }
}

export default withTheme(WatchListButton);



// WEBPACK FOOTER //
// ./src/Components/WatchListButton.tsx